import type { FilterBuilderResponseUnion } from '@moment/trading-types/filter'
import type { TargetBandState } from '@/components/molecules/target-band'
import type { AllocationConstraintState } from '@/reducers/model-builder'

export const isValidCondition = (
  condition: AllocationConstraintState['conditions'][number],
) => {
  const { field, operator, inputValue } = condition
  return (
    field !== null &&
    operator !== null &&
    inputValue !== null &&
    inputValue.toString().length > 0
  )
}

export const isValidAllocation = (allocation: AllocationConstraintState) => {
  return (
    isValidTargetBand(allocation.targetBand) &&
    hasValidConditions(allocation.conditions)
  )
}

/** A band is only a constraint once it bounds one side; a target alone is not. */
export const isValidTargetBand = (targetBand: TargetBandState | null) => {
  if (!targetBand) return false
  const { min, max } = targetBand
  return Boolean(min) || Boolean(max)
}

const hasValidConditions = (conditions: FilterBuilderResponseUnion[]) => {
  return conditions.some(isValidCondition)
}
